
import { handleActions } from 'redux-actions'

const initial = {
  elements: {},
  gist: '',
  html: '',
  previewMode: 'desktop',
  showPreview: true,
  uiSize: 'middle',
  value: ''
}

export default handleActions({

  SWITCH_PREVIEW: (state, { payload: previewMode }) => ({ ...state, previewMode }),
  TOGGLE_PREVIEW: state => ({ ...state, showPreview: !state.showPreview }),

}, initial)
